import { LegacyUserRole, UserRole, UserRoleValue } from '@/types/user';
import { getAccessRoleLabel } from '@/utils/rbac';

const LEGACY_CURATOR_ROLES: LegacyUserRole[] = ['AGENT', 'EDITOR', 'CREATIVE'];

export function isLegacyUserRole(role: string): role is LegacyUserRole {
  return LEGACY_CURATOR_ROLES.includes(role as LegacyUserRole);
}

export function normalizeUserRole(role: UserRoleValue | string): UserRole {
  if (role === 'ADMIN_ROOT' || role === 'ADMIN' || role === 'CURATOR') {
    return role;
  }

  if (isLegacyUserRole(role)) {
    return 'CURATOR';
  }

  return 'CURATOR';
}

export function getRoleDisplayName(role: UserRoleValue | string): string {
  return getAccessRoleLabel(role);
}

export function toFormUserRole(role: UserRoleValue | string): UserRole {
  return normalizeUserRole(role);
}
